import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Programmatic User Management',
  content: `
You can manage users and their roles programmatically using the Pliable API. All user management endpoints require **Admin** role credentials.

See [Pliable API](/docs/pliable-api) for instructions on generating API credentials and retrieving an access token.

## List Users

Retrieve all users in your account:

\`\`\`bash
curl -X GET "https://app.pliable.co/api/v1/tenant-config/users" \\
  -H "Authorization: Bearer YOUR_ACCESS_TOKEN_HERE"
\`\`\`

The response contains a \`records\` array of user objects, each including the user's \`id\`, \`email\`, \`name\`, and their assigned \`roles\`.

## List Available Roles

Retrieve the list of roles you can assign to users:

\`\`\`bash
curl -X GET "https://app.pliable.co/api/v1/tenant-config/roles" \\
  -H "Authorization: Bearer YOUR_ACCESS_TOKEN_HERE"
\`\`\`

The response contains a \`records\` array of role objects with \`id\`, \`key\`, and \`name\` fields. The available roles are:

| Role Key | Description |
|----------|-------------|
| **Admin** | Full access to all features including user management and settings |
| **Builder** | Can create and modify data sources, models, and visualizations |
| **Onboarder** | Limited access for initial setup and onboarding workflows |
| **ReadOnly** | View-only access to dashboards and data |
| **ReadOnly_Partner** | View-only access scoped for external partners |

## Update a User's Roles

Replace a user's roles by sending the desired set of role IDs. First, use the **List Users** and **List Available Roles** endpoints above to get the \`user_id\` and \`role_id\` values you need.

\`\`\`bash
curl -X PUT "https://app.pliable.co/api/v1/tenant-config/users/USER_ID/roles" \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer YOUR_ACCESS_TOKEN_HERE" \\
  -d '{
    "role_ids": ["ROLE_ID_1", "ROLE_ID_2"]
}'
\`\`\`

This endpoint performs a full replacement — the user will have exactly the roles specified in \`role_ids\`, and any previously assigned roles not in the list will be removed.

A successful response returns:

\`\`\`json
{
    "ok": true
}
\`\`\`
`,
};

export default doc;
